import React from "react"
import Proptypes from "prop-types"
import * as styles from "./__styles__/video.module.scss"

function getYoutubeId(url) {
  return decodeURIComponent(url)
    .match(/(\?|&)v=([^&]+)/)
    .pop()
}

export default function Video({ video }) {
  return (
    <div className={styles.video}>
      <iframe
        width="547"
        height="312"
        src={`https://www.youtube-nocookie.com/embed/${getYoutubeId(video)}`}
        referrerPolicy="strict-origin-when-cross-origin"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded video"
      />
    </div>
  )
}

Video.propTypes = {
  /**
   * The full YouTube URL
   */
  video: Proptypes.string.isRequired,
}
